export default __webpack_public_path__ + "static/media/playstoredownloads.523af51c.png";